import BillingDateConfigContainer from './BillingDateConfigContainer'

export default function BillingDateConfigScreen() {
    return <BillingDateConfigContainer />
}
